import React from 'react'
import './app.css';
// import { config } from "@wayke-se/ecom";

import Routed from './components/Routed'
import AppContext from './components/context/AppContext';
import SearchContext from './components/context/SearchContext';

const App = (props) => {

	// Wayke ecom config
	// config.bind({
	// 	api: {
	// 		address: 'https://ecom.wayke.se',
	// 	}
	// });

	// App context
	const app = {
		...props
	}

	return (
		<>
			<AppContext.Provider value={app}>
				<SearchContext.Provider>
					<Routed />
				</SearchContext.Provider>
			</AppContext.Provider>	
		</>
	)
}

export default App
